import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { TherapistArea } from "@/Modules/Models/Domain/Therapist";
import type { TherapistAreaUi } from "../Models/Ui/Therapist";

class TherapistAreaToTherapistAreaUiTransformer implements Transformer<TherapistArea[], TherapistAreaUi[]> {
  transform(therapistArea: TherapistArea[]): TherapistAreaUi[] {
    const therapistAreas = therapistArea.reduce<Record<string, TherapistAreaUi>>(
      (areas, currentArea: TherapistArea) => {
        areas[currentArea.areaId] = areas[currentArea.areaId]
          ? areas[currentArea.areaId]
          : {
              subAreas: [],
              i18nArea: "",
            };
        const subAreas = areas[currentArea.areaId].subAreas ? areas[currentArea.areaId].subAreas : [];
        const subArea = {
          id: currentArea.subAreaId,
          i18n: currentArea.subAreaI18n,
          active: currentArea.isActive,
        };
        subAreas.push(subArea);
        areas[currentArea.areaId].subAreas = subAreas;
        areas[currentArea.areaId].i18nArea = currentArea.areaI18n;
        return areas;
      },
      {}
    );
    return Object.keys(therapistAreas).map((id) => therapistAreas[id]);
  }
}

export default TherapistAreaToTherapistAreaUiTransformer;
